// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/route_theme.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { RouteThemeService } from "./route_theme_pb";

/**
 * ListRouteThemes returns the active themes, in display order.
 *
 * @generated from rpc travplaces.v1.RouteThemeService.ListRouteThemes
 */
export const listRouteThemes = RouteThemeService.method.listRouteThemes;
